import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class TeamsRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return this.modelFor("new-group.show")
  }
}
